import { UserSortKey, UserTableSort } from "Shared/types/Sort";
import { Header } from "Components/DP/DPTable/DPTable";
import SortableHeaderCell from "Components/Pages/Users/UserTable/SortableHeaderCell/SortableHeaderCell";
import React from "react";
import { GetEmployeeProfilesQueryProps } from "Shared/types/EmployeeProfiles";
const sortableHeaders: [string, UserSortKey][] = [
  ["First Name", "firstName"],
  ["Last Name", "lastName"],
  ["User ID", "primaryId"],
  ["Location", "location"],
];

const unsortableHeaders = [
  { tableHeaderKey: "payGroups", header: "Pay Group(s)" },
  { tableHeaderKey: "dailyPayStatus", header: "DailyPay Status" },
  { tableHeaderKey: "employmentStatus", header: "Employment Status" },
  { tableHeaderKey: "benefitType", header: "Benefit Type" },
];

type Props = {
  queryProps: GetEmployeeProfilesQueryProps;
  hideColumns: string[];
  updateSort: (sort: UserTableSort) => void;
};

export default function createUserTableHeaders({
  queryProps,
  hideColumns = [],
  updateSort,
}: Props): Header[] {
  const userTableHeaders: (JSX.Element | string)[] = sortableHeaders
    .filter(([_, sortKey]) => !hideColumns.includes(sortKey))
    .map(([name, sortKey]) => (
      <SortableHeaderCell
        name={name}
        sortKey={sortKey}
        id={`user-${sortKey}`}
        sort={queryProps.sort}
        updateSort={updateSort}
      />
    ));

  unsortableHeaders.forEach(({ tableHeaderKey, header }) => {
    if (!hideColumns.includes(tableHeaderKey)) {
      userTableHeaders.push(header);
    }
  });

  return userTableHeaders;
}
